import React from 'react';
import CardContainer from './CardContainer';

export default function AutomateSection({styles}) {
  return (
    <section className={`${styles.container} ${styles.automateSection}`}>
          <div className={styles.headingContainer}>
            <h1 className={styles.sectionTitle}>
              Automate Every Revenue-Driving Touchpoint
            </h1>
            <p className={styles.sectionSubTitle}>
              Set it once, endless gains. Our AI handles the entire customer
              journey so you don't have to.
            </p>
          </div>

          <div className={`${styles.columnCard} ${styles.provenFlows}`}>
            <CardContainer className={`${styles.columnImage} half-width`}>
              <img
                className={styles.flowStatsImage}
                src="/images/report.webp"
                alt="Maximize Marketing ROI"
              />
            </CardContainer>
            {/* <FlowGraph className={`${styles.columnCard} provenFlows`} /> */}
            <div className={`${styles.columnText} half-width`}>
              <h2 className={styles.columnTextHeading}>
                10 Proven flows that print money
              </h2>
              <p className={styles.columnTextPara}>
                Stop leaving revenue on the table.
              </p>
              <p className={styles.columnTextPara}>
                Get instant access to battle-tested automation flows that
                recover lost sales and maximize customer lifetime value.
              </p>
            </div>
          </div>

        </section>
  )};